<template>
    <v-main class="primary">
        <transition name="fade" mode="out-in">
            <loader-component v-if="loading"></loader-component>
            <router-view v-else></router-view>
        </transition>
    </v-main>
</template>
<style scoped>
    .fade-enter-active,
    .fade-leave-active {
        transition-duration: 0.3s;
        transition-property: opacity;
        transition-timing-function: ease;
    }

    .fade-enter,
    .fade-leave-active {
        opacity: 0;
    }
</style>
<script>
    import { mapActions, mapMutations, mapGetters } from 'vuex'
    import LoaderComponent from '../../components/LoaderComponent.vue'

    export default {
        components: {
            LoaderComponent,
        },

        async created() {
            this.ENABLE_LOADER()
            this.$vuetify.theme.themes.light.primary = '#FFF8F2'
            this.$vuetify.theme.themes.light.secondary = '#A85113'
            this.$vuetify.theme.themes.light.accent = '#F58634'
            this.$vuetify.theme.themes.light.anchor = '#A85113'
            await this.fetchTiposItem()
            await this.fetchEquipo()
            await this.fetchEstatusEquipamiento()

            this.DISABLE_LOADER()
        },

        computed: {
            ...mapGetters({
                loading: 'getLoader',
            }),
        },

        methods: {
            ...mapActions('personal', ['fetchPersonal']),
            ...mapActions('tipoItem', ['fetchTiposItem']),
            ...mapActions('equipo', ['fetchEquipo']),
            ...mapActions('estatusEquipamiento', ['fetchEstatusEquipamiento']),
            ...mapMutations(['DISABLE_LOADER', 'ENABLE_LOADER']),
        },
    }
</script>
